// Set resume search alert recency  ***********************
// pathname: /v1/resume-search-alert/recency/{id}/{recency}
// **********************************************************
import { GenericV1ErrorsArray, useSwrMutationApi } from '@hooks/useSwrApi';

interface UseSwrSetResumeSearchAlertRecencyProps {
  locale?: Locale;
  id: string;
  recency: 1 | 2; // 1 = Daily, 2 = Weekly
  successCallback?: () => void;
  errorCallback?: (errors: GenericV1ErrorsArray) => void;
}

/**
 * @description SWR mutation: Set resume search alert recency by id.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param id - string. The id of the resume search alert.
 * @param recency - 1 | 2. The recency value (1 = Daily, 2 = Weekly).
 * @param successCallback - function. The callback to execute after successful update.
 * @param errorCallback - function. The callback to execute on error.
 */
export const useSwrSetResumeSearchAlertRecency = (props: UseSwrSetResumeSearchAlertRecencyProps) => {
  const {
    locale = 'ro',
    id,
    recency,
    successCallback,
    errorCallback,
  } = props;

  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, never>({
    url: `/v1/resume-search-alert/recency/${id}/${recency}`,
    locale,
    fetcherConfig: {
      method: 'POST',
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
      onError: (errors) => {
        if (errorCallback) errorCallback(errors);
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};

